<template>
    <v-container  class="webbox-image-styling">
        <v-switch class="pfcl1618818401 pr-3" 
                :value="contain" @change="$emit('update:contain', $event)"
                :label="$t('webboxes.styling.image.contain')"
            >
            </v-switch>
            <v-switch
                class="pfcl1618818415 pr-3" 
                v-model="customHeight"
                :label="$t('webboxes.styling.image.height.label')"
            />
            <label class="v-label d-block mt-5">{{$t('webboxes.styling.image.height.title')}}</label>
            <v-slider 
                v-model="heightInt"
                :disabled="!customHeight"
                thumb-size="24"
                :thumb-label="true"
                min="1"
                max="50"
                hide-details
                class="pfcl1618818420 align-center"
                >
                <template v-slot:append>
                <v-text-field
                v-model="heightInt"
                class="mt-0 pt-0"
                hide-details
                single-line
                suffix="em"
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template>
            </v-slider>
    </v-container>
</template>
<script>
export default {
    name: 'ImageStyling',
    props: { contain: Boolean, height: String },
    data() {
        return {
            customHeight: !!this.height
        }
    },
    watch: {
        height(val) {
            if(val) {
                this.customHeight = true;
            }
        },
        customHeight(val) {
            if(!val) {
                this.$emit(`update:height`, null);
            }
        }
    },
    computed: {
        heightInt: {
            get() {
                return this.height ? parseInt(this.height.replace(/\D/g, '')) : null;
            },
            set(val) {
                if(this.customHeight) {
                    this.$emit(`update:height`, `${val}em`);
                }
            }
        }
    },
    methods: {
    }
}
</script>